"use client";

import { motion } from "framer-motion";

interface WorkIntroProps {
  intro: string;
}

export function WorkIntro({ intro }: WorkIntroProps) {
  return (
    <motion.p
      data-cy="work-intro"
      className="text-md md:text-lg mb-12 text-content max-w-3xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
    >
      {intro}
    </motion.p>
  );
}